import React from 'react';
import { Typography } from 'antd';
import {
  ShoppingCartOutlined,
  InboxOutlined,
  CarOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';
import CardContainer from '../Card';

const { Text } = Typography;

export default function DeliveryStatsCards({ 
  deliveryData = {}, 
  showOnly = [] // Array of card keys to show, empty means show all
}) {
  const stats = deliveryData.orders || {};

  const allCardData = [
    {
      key: 'new-order',
      label: 'New Order',
      value: stats.total_paid || 0,
      icon: ShoppingCartOutlined,
      color: '#4F7CFF'
    },
    {
      key: 'packed-orders',
      label: 'Packed Orders',
      value: stats.total_packed || 0,
      icon: InboxOutlined,
      color: '#52c41a'
    },
    {
      key: 'out-for-delivery',
      label: 'Out For Delivery',
      value: stats.total_out_for_delivery || 0,
      icon: CarOutlined,
      color: '#722ed1'
    },
    {
      key: 'delivered',
      label: 'Delivered',
      value: stats.delivered || 0,
      icon: CheckCircleOutlined,
      color: '#1890ff'
    },
    {
      key: 'reschedule',
      label: 'Reschedule',
      value: stats.reschedule || 0,
      icon: ClockCircleOutlined,
      color: '#ff4d4f'
    }
  ];

  // Filter cards based on showOnly prop
  const cardData = showOnly.length > 0 
    ? allCardData.filter(card => showOnly.includes(card.key))
    : allCardData;

  if (cardData.length === 0) return null;

  return (
    <div className="delivery-cards-container" style={{ marginBottom: 24 }}>
      {cardData.map(({ key, label, value, icon: Icon, color }) => (
        <CardContainer
          key={key}
          bodyStyle={{ padding: "20px" }}
          bordered={false}
          className="delivery-stat-card"
        >
          <div className="delivery-card-content">
            <div className={`delivery-card-icon ${key}`}>
              <Icon style={{ fontSize: 20, color }} />
            </div>
            <div className="delivery-card-info">
              <Text className="delivery-card-label">{label}</Text>
              <Text className="delivery-card-value">{value}</Text>
            </div>
          </div>
        </CardContainer>
      ))}
    </div>
  );
}